module.exports = __webpack_public_path__ + "static/media/non_ulip.e84b3b32.mp3";